import React from "react";
import { Tooltip } from "antd";
import { FaPlus } from "react-icons/fa6";
import { InjuryTooltip } from "./tooltips/InjuryTooltip";

// Pure — the injury "+" marker + tooltip (matches the cell's injury block).
export const InjuryMarker = ({ injuries, uniqueKey = "" }) => {
    if (!injuries || injuries.length === 0) return null;
    return (
        <Tooltip title={<InjuryTooltip injuries={injuries} uniqueKey={uniqueKey} />}>
            <FaPlus style={{ color: "#888888" }} />
        </Tooltip>
    );
};
